import { Card, Flex, Typography } from "djuno-design";
import React, { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import {
  accordionPageUrl,
  alertPageUrl,
  buttonPageUrl,
  dropdownPageUrl,
  emptyStatePageUrl,
  checkboxPageUrl,
  inputPageUrl,
  loadingPageUrl,
  modalPageUrl,
  popoverPageUrl,
  paginationPageUrl,
  panelLayoutsPageUrl,
  secureCopyPageUrl,
  selectPageUrl,
  sidebarPageUrl,
  skeletonPageUrl,
  stepsPageUrl,
  switcherPageUrl,
  textareaPageUrl,
  tooltipPageUrl,
  typographyPageUrl,
  dividerPageUrl,
  tabsPageUrl,
  cardPageUrl,
  flexPageUrl,
  simpleTablePageUrl,
  jsonViewerPageUrl,
  themeChangersPageUrl,
  codeViewerPageUrl,
  TagPageUrl,
} from "../urls";

const { Title, Text } = Typography;
const ComponentsOverviewPage = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <Flex direction="col">
          <Title level={4}>Components Overview</Title>
          <Text size="sm" style={{ marginBottom: 30 }}>
            djuno-design (dd) provides plenty of UI components to enrich your
            web applications, and we will improve components experience
            consistently.
          </Text>
        </Flex>
      </Flex>
      <div className="flex flex-wrap gap-4">
        <ComponentCard
          to={panelLayoutsPageUrl}
          title={<Text size="sm">panel layouts</Text>}
        >
          <Title level={3}>{`<PanelLayout />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={typographyPageUrl}
          title={<Text size="sm">typography</Text>}
        >
          <Title level={3}>{`<Typography />`}</Title>
        </ComponentCard>
        <ComponentCard to={buttonPageUrl} title={<Text size="sm">button</Text>}>
          <Title level={3}>{`<Button />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={loadingPageUrl}
          title={<Text size="sm">loading</Text>}
        >
          <Title level={3}>{`<Loading />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={tooltipPageUrl}
          title={<Text size="sm">tooltip</Text>}
        >
          <Title level={3}>{`<Tooltip />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={dividerPageUrl}
          title={<Text size="sm">divider</Text>}
        >
          <Title level={3}>{`<Divider />`}</Title>
        </ComponentCard>
        <ComponentCard to={alertPageUrl} title={<Text size="sm">alert</Text>}>
          <Title level={3}>{`<Alert />`}</Title>
        </ComponentCard>
        <ComponentCard to={stepsPageUrl} title={<Text size="sm">steps</Text>}>
          <Title level={3}>{`<Steps />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={skeletonPageUrl}
          title={<Text size="sm">skeleton</Text>}
        >
          <Title level={3}>{`<Skeleton />`}</Title>
        </ComponentCard>
        <ComponentCard to={modalPageUrl} title={<Text size="sm">modal</Text>}>
          <Title level={3}>{`<Modal />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={dropdownPageUrl}
          title={<Text size="sm">dropdown</Text>}
        >
          <Title level={3}>{`<Dropdown />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={emptyStatePageUrl}
          title={<Text size="sm">emptyState</Text>}
        >
          <Title level={3}>{`<Emptysate />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={accordionPageUrl}
          title={<Text size="sm">accordion</Text>}
        >
          <Title level={3}>{`<accordion />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={paginationPageUrl}
          title={<Text size="sm">pagination</Text>}
        >
          <Title level={3}>{`<Pagination />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={sidebarPageUrl}
          title={<Text size="sm">sidebar</Text>}
        >
          <Title level={3}>{`<Sidebar />`}</Title>
        </ComponentCard>
        <ComponentCard to={inputPageUrl} title={<Text size="sm">input</Text>}>
          <Title level={3}>{`<Input />`}</Title>
        </ComponentCard>
        <ComponentCard to={selectPageUrl} title={<Text size="sm">select</Text>}>
          <Title level={3}>{`<Select />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={textareaPageUrl}
          title={<Text size="sm">textarea</Text>}
        >
          <Title level={3}>{`<Textarea />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={switcherPageUrl}
          title={<Text size="sm">switcher</Text>}
        >
          <Title level={3}>{`<Switcher />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={checkboxPageUrl}
          title={<Text size="sm">checkbox</Text>}
        >
          <Title level={3}>{`<Checkbox />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={popoverPageUrl}
          title={<Text size="sm">popover</Text>}
        >
          <Title level={3}>{`<Popover />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={secureCopyPageUrl}
          title={<Text size="sm">secureCopy</Text>}
        >
          <Title level={3}>{`<SecureCopy />`}</Title>
        </ComponentCard>
        <ComponentCard to={tabsPageUrl} title={<Text size="sm">tabs</Text>}>
          <Title level={3}>{`<Tabs />`}</Title>
        </ComponentCard>
        <ComponentCard to={cardPageUrl} title={<Text size="sm">card</Text>}>
          <Title level={3}>{`<Card />`}</Title>
        </ComponentCard>
        <ComponentCard to={flexPageUrl} title={<Text size="sm">flex</Text>}>
          <Title level={3}>{`<Flex />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={simpleTablePageUrl}
          title={<Text size="sm">table</Text>}
        >
          <Title level={3}>{`<SimpleTable />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={jsonViewerPageUrl}
          title={<Text size="sm">json-viewer</Text>}
        >
          <Title level={3}>{`<JsonViewer />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={themeChangersPageUrl}
          title={<Text size="sm">theme-changers</Text>}
        >
          <Title level={3}>{`<ThemeChanger />`}</Title>
        </ComponentCard>
        <ComponentCard
          to={codeViewerPageUrl}
          title={<Text size="sm">code-viewer</Text>}
        >
          <Title level={3}>{`<CodeViewer />`}</Title>
        </ComponentCard>
        <ComponentCard to={TagPageUrl} title={<Text size="sm">Tag</Text>}>
          <Title level={3}>{`<Tag />`}</Title>
        </ComponentCard>
      </div>
    </div>
  );
};

export const ComponentCard: React.FC<
  PropsWithChildren<{ to: string; title?: React.ReactNode }>
> = ({ to, title, children }) => {
  return (
    <Link to={to}>
      <Card
        title={title}
        className="!w-auto hover:shadow-lg transition-all duration-300 "
      >
        {children}
      </Card>
    </Link>
  );
};
export default ComponentsOverviewPage;
